import { createContext, useContext, useState } from 'react';
import { defaultThemes } from '../../design-tokens';
import { TypographyWrapper, ViyaThemeContainer } from '../../theme';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This is used internally by AppRoot. Consumers should not need to use this in isolation. Creates internal state for the currently selected theme.
 */
export const ThemeStateProvider = props => {
  const [theme, setTheme] = useState({
    type: 'application',
    theme: {
      ...defaultThemes.light,
      enableNovaTokens: true
    }
  });
  return /*#__PURE__*/_jsx(ViyaThemeContainer, {
    themeDefinition: theme,
    viyaEndpoint: props.viyaEndpoint,
    style: {
      width: '100%',
      height: '100%'
    },
    children: /*#__PURE__*/_jsx(SetThemeContext.Provider, {
      value: setTheme,
      children: /*#__PURE__*/_jsx(TypographyWrapper, {
        requestFonts: props.requestFonts,
        ignoreRootFontSize: props.ignoreRootFontSize,
        dataProvider: props.typographyDataProvider,
        children: props.children
      })
    })
  });
};
const SetThemeContext = /*#__PURE__*/createContext(undefined);

/**
 * Hook for using the SetThemeContext
 */
export function useSetTheme() {
  return useContext(SetThemeContext);
}
//# sourceMappingURL=ThemeStateProvider.js.map